import React, { useContext } from 'react';
import { UserContext } from '../../Context/UserContextProvider';
import axios from '../../../axios/index';

import FormControlLabel from '@mui/material/FormControlLabel';
import { IOSSwitch } from '../DashboardArchivedFiles/ArchiveDetail/IOSSwitch';

import styles from "../DashboardFileManagement/DashboardFileManagement.module.css"

import arrowLeftBlue from "../../../assets/img/DashboardICons/ArrowLeftBlue.svg"

export default function FileHiddenAndLimitation(props) {
    const { userToken, permissions } = useContext(UserContext);

    return (
        <>
            <div className='w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3'>
                <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mt-4 mb-4 px-3'>
                    <div className={`d-flex align-items-start justify-content-start flex-column my-lg-0 my-3 py-3 px-2 ${styles.card_box_container}`}>
                        <div className='d-flex align-items-center justify-content-center'>
                            <FormControlLabel
                                sx={{ m: 0 }}
                                onChange={switchHandler}
                                control={<IOSSwitch sx={{ m: 1 }} />}
                                checked={props.hiddenFile}
                            />
                            {
                                props.hiddenFile
                                    ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" fill="currentColor" className="bi bi-eye-slash" viewBox="0 0 16 16">
                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                    </svg>
                            }
                            <div className={`me-2 ${styles.show_card_title}`}>
                                عدم نمایش فایل به کاربر
                            </div>
                        </div>
                        <div className='w-100 d-flex align-items-center justify-content-end mb-2'>
                            <div className={`ms-4 ${styles.card_box_secondory_text}`}>
                                با فعال کردن این گزینه فایل مورد نظر از دید کاربران پنهان خواهد ماند.
                            </div>
                        </div>
                    </div>

                    {permissions?.find((item) => item === 16) === 16 ?
                        null
                        :
                        <div className={`d-flex align-items-start justify-content-start flex-column my-lg-0 my-3 p-3 ${styles.card_box_container}`}>
                            <div className='w-100 d-flex align-items-center justify-content-between mb-3'>
                                <div className={styles.show_card_title} >
                                    محدود سازی فایل برای کاربران
                                </div>
                                <img className='pointer' src={arrowLeftBlue} alt="icon" onClick={() => props.setShowModal((prev) => {
                                    return { ...prev, openLimitation: true };
                                })}
                                />
                            </div>
                            <div className='w-100 d-flex align-items-center justify-content-start mb-2'>
                                <div className={styles.card_box_secondory_text}>
                                    با محدودسازی فایل از نمایش تمام ایتم ها به کاربر جلوگیری کنید
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )

    async function switchHandler(event) {
        if (event.target.checked === true) {
            var data = {
                "estateId": props.id,
                "status": 1
            }
            const addSave = await axios.post(
                "Estate/ChangeStatus",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            // console.log(addSave)
            if (props.new) {
                props.setHiddenFile((prev) => {
                    return { ...prev, hiddenFile: true };
                });
            } else {
                props.setHiddenFile(true)
            }
        } else {
            const data = {
                "estateId": props.id,
                "status": 2
            }
            const addSave = await axios.post(
                "Estate/ChangeStatus",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            // console.log(addSave)
            if (props.new) {
                props.setHiddenFile((prev) => {
                    return { ...prev, hiddenFile: false };
                });
            } else {
                props.setHiddenFile(false)
            }
            // props.setHiddenFile(false)
        }
    };
}
